import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn, numberFormatter } from "@/lib/utils";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { Button, Divider, Tag, Typography } from "@bookips/sds";
import Image from "next/image";
import Link from "next/link";
import React from "react";
const BillingPlanCard = (param)=>{
    let { type , thumbnailUrl , tagText , title , keyText , bodyText , linkTexts , price , pricePeriod , originalPrice , discountRate , isUseDiscountRate , buttonLabel , buttonUrl , onButtonClick  } = param;
    // 반응형 너비 (커스텀 브레이크포인트: sm=744px, md=1080px, lg=1200px)
    // md 미만(스크롤 모드): sm 미만 240px, sm 이상 320px
    // md 이상(그리드 모드): 부모가 크기 결정
    const scrollWidthClass = "w-[240px] min-w-[240px] sm:w-[320px] sm:min-w-[320px]";
    const { isMobile  } = useWindowDimensions();
    return /*#__PURE__*/ _jsxs("div", {
        className: cn("relative flex h-full flex-col gap-4 rounded-md bg-white p-5", // 스크롤 모드에서는 shrink 방지, 그리드 모드에서는 부모에 맞춤
        "shrink-0 md:w-auto md:min-w-0 md:shrink", "max-sm:p-3", type === "main" ? "border border-gray-700" : "border border-gray-100", scrollWidthClass),
        children: [
            tagText && /*#__PURE__*/ _jsx(Tag, {
                color: "red",
                bold: true,
                size: isMobile ? "sm" : "md",
                className: "max-sm:size-sm bg-status-error absolute top-5 right-5 text-white max-sm:top-3 max-sm:right-3",
                children: tagText
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col gap-3",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            thumbnailUrl && /*#__PURE__*/ _jsx("div", {
                                className: "relative h-10 w-10 overflow-hidden rounded-md max-sm:h-[32px] max-sm:w-[32px]",
                                children: /*#__PURE__*/ _jsx(Image, {
                                    src: thumbnailUrl,
                                    alt: title,
                                    fill: true,
                                    className: "h-full w-full object-cover"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h6",
                                className: "text-primary max-sm:typo-subtitle1",
                                children: title
                            }),
                            keyText && /*#__PURE__*/ _jsx(Typography, {
                                variant: "body2",
                                className: "text-primary-main max-sm:typo-caption",
                                children: keyText
                            }),
                            bodyText && /*#__PURE__*/ _jsx(Typography, {
                                variant: "body2",
                                className: "text-secondary max-sm:typo-caption whitespace-pre-line",
                                children: bodyText
                            })
                        ]
                    }),
                    linkTexts && linkTexts.length > 0 && /*#__PURE__*/ _jsx(Divider, {
                        className: "bg-gray-900/20"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex flex-col gap-2 max-sm:gap-1",
                        children: linkTexts && linkTexts.map((linkText)=>/*#__PURE__*/ _jsx(React.Fragment, {
                                children: /*#__PURE__*/ _jsx(Link, {
                                    href: linkText.url,
                                    children: /*#__PURE__*/ _jsx(Typography, {
                                        variant: "body2",
                                        className: "text-secondary-main typo-body2",
                                        children: linkText.text
                                    })
                                })
                            }, linkText.text))
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "mt-auto flex flex-col items-end",
                children: [
                    isUseDiscountRate && originalPrice && discountRate && /*#__PURE__*/ _jsx("div", {
                        className: "text-muted flex items-center",
                        children: /*#__PURE__*/ _jsxs(Typography, {
                            variant: "body2",
                            className: "max-sm:typo-caption line-through",
                            children: [
                                numberFormatter(originalPrice),
                                "원",
                                pricePeriod ? "/".concat(pricePeriod) : ""
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-baseline gap-1",
                        children: [
                            isUseDiscountRate && discountRate && /*#__PURE__*/ _jsxs(Typography, {
                                variant: "h6",
                                className: "text-status-error max-sm:typo-subtitle1",
                                children: [
                                    discountRate,
                                    "%"
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "h6",
                                className: "text-primary max-sm:typo-subtitle1",
                                children: price
                            }),
                            pricePeriod && /*#__PURE__*/ _jsx(Typography, {
                                variant: "body2",
                                className: "text-primary",
                                children: "/".concat(pricePeriod)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Link, {
                href: buttonUrl,
                onClick: onButtonClick,
                children: /*#__PURE__*/ _jsx(Button, {
                    variant: type === "main" ? "fill" : "stroke",
                    color: type === "main" ? "primary" : "secondary",
                    size: "md",
                    className: "w-full",
                    children: buttonLabel
                })
            })
        ]
    });
};
export default BillingPlanCard;
